module.exports = __webpack_public_path__ + "img/filter.2f6a02ab.svg";